var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSvgCarrinhoVazio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 203.587,
    height: 224.992,
    viewBox: "0 0 203.587 224.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8251.938 22192.653)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 8250.422, -22124.885)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.838 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.782,35.913A9.761,9.761,0,0,0,137.927,32H8.246L23.23,110.667h97.844c4.374,0,8.255-10.2,8.255-10.2l18.057-55.934A9.764,9.764,0,0,0,145.782,35.913Z",
    transform: "translate(36.16 -15.237)",
    fill: "#f3f6f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.038,31H137.927a10.834,10.834,0,0,1,10.42,13.811l-.01.033-18.074,55.983a37.736,37.736,0,0,1-2.562,5.254c-2.206,3.707-4.436,5.587-6.627,5.587H22.4ZM146.428,44.246A8.834,8.834,0,0,0,137.927,33H9.455l14.6,76.667h97.016c1.393,0,3.131-1.629,4.9-4.588a36.415,36.415,0,0,0,2.416-4.942Z",
    transform: "translate(36.16 -15.237)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.513,133.763a14.75,14.75,0,1,0,14.75,14.75A14.75,14.75,0,0,0,212.513,133.763Zm-88.5,0a14.75,14.75,0,1,0,14.75,14.75A14.75,14.75,0,0,0,124.013,133.763Zm95.875-24.583H125.2L106.675,11.925a7.375,7.375,0,0,0-7.245-6L70.375-1a7.375,7.375,0,0,0,0,14.75l22.952,6.93,18.525,97.255a7.375,7.375,0,0,0,7.245,5.995H219.888a7.375,7.375,0,0,0,0-14.75Z",
    transform: "translate(-63 1)",
    fill: "#73a91b"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M8,23.5a1.5,1.5,0,0,1-1.41-.988l-8-22a1.5,1.5,0,0,1,.9-1.922,1.5,1.5,0,0,1,1.922.9l8,22A1.5,1.5,0,0,1,8,23.5Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 8327.726, -22169.408)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,39.5A1.5,1.5,0,0,1-1.5,38V0A1.5,1.5,0,0,1,0-1.5,1.5,1.5,0,0,1,1.5,0V38A1.5,1.5,0,0,1,0,39.5Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 8345.801, -22190.816)",
    fill: "#73a91b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,23.5a1.5,1.5,0,0,1-.512-.091,1.5,1.5,0,0,1-.9-1.922l8-22a1.5,1.5,0,0,1,1.922-.9A1.5,1.5,0,0,1,9.41.513l-8,22A1.5,1.5,0,0,1,0,23.5Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 8362.499, -22178.727)",
    fill: "#73a91b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgCarrinhoVazio);
export default __webpack_public_path__ + "static/media/svg-carrinho-vazio.1c4ac26d94ff208174ff21d2b5207745.svg";
export { ForwardRef as ReactComponent };